import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

const useTitleName = () => {
    const callApi = useCallApi()
    const [state, setState] = useState([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<any>({
                url: umServinceURL.getLookupTitle,
            })
            setState(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { state }
}

export default useTitleName
